import { InjectionToken } from '@angular/core';

export const EQA_TAKE_ONLY_TRUSTED_EVENTS: InjectionToken<boolean> = new InjectionToken<boolean>(
	'This token need for override behavior the `pressedObservable` function',
	{
		factory: () => true,
	},
);
